module.exports = __webpack_public_path__ + "static/media/244-130Z2154Z8.8bb15968.jpg";